export interface SocioViewModel {
  dscTipoPessoa: string;
  numCpfCnpj: string;
  dscNome: string;
  datNascimento?: Date | string | null;
  datFundacao?: Date | string | null;
  dscNomePai: string | null;
  dscNomeMae: string | null;
}

export interface KycRequestViewModel {
  CodAcesso?: number;
  CodTipoEntidade?: number; 
  RazaoSocial?: string;
  Cnpj?: string;
  CodCliente?: number;
  DataFundacao?: Date | string | null;
  DataCadastro?: Date | string | null;
  DataLiberacao?: Date | string | null;
  Parceria?: string;
  socios?: SocioViewModel[];
  CodAcessoSubstituto?: number | null;
  LoginSubstituto?: string | null;
  Guid?: string;
  DthUltimoEnvio?: Date | string | null;
  Status?: string | null;
  TravarTela?: boolean | false;
  MsgRetornoSwap?: string | null;
}

export interface KycResponse {
  sucesso: boolean;
  mensagens: string[];
  retorno: any;
}